// extracted by mini-css-extract-plugin
export default {"StickyBlock":"bfe_a bie_bj"};